import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'vi-radio-button',
  templateUrl: 'radio-button.component.html',
  styleUrls: ['radio-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViRadioButtonComponent {
  @Input() value: any;
  @Input() label: string;
  @Input() icon: string;
  @Input() color: ThemePalette = 'primary';
  @Input() checked: boolean;
  @Input() disabled: boolean;
  @Output() optionChange: EventEmitter<any> = new EventEmitter<any>();

  onChange(change: MatRadioChange): void {
    this.optionChange.emit(change.value);
  }
}
